import { Box } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import PendingProjectTasksDataCollection from 'modules/project_management/components/tables/PendingProjectTasksDataCollection'

import * as styles from './index.vanilla.css'

interface IPendingTasksSidePanel {
  assigneeEmployeeId: number
  onClose: () => void
  projectId?: number
  projectName?: string
  showPendingTasksSidePanel: boolean
}

const PendingTasksSidePanel = ({
  assigneeEmployeeId,
  onClose,
  projectId,
  projectName,
  showPendingTasksSidePanel,
}: IPendingTasksSidePanel) => {
  return (
    <Box style={{ paddingBottom: '0px' }}>
      <Sidepanel
        title={i18n.t('project_management.my_projects.overview.pending_tasks.title')}
        open={showPendingTasksSidePanel}
        width="extended"
        onClose={onClose}
      >
        <div className={styles.pendingTasksSidePanel}>
          <Box gap="s16">
            <PendingProjectTasksDataCollection
              assigneeEmployeeId={assigneeEmployeeId}
              projectId={projectId}
              projectName={projectName}
            />
          </Box>
        </div>
      </Sidepanel>
    </Box>
  )
}

export default PendingTasksSidePanel
